import { render, staticRenderFns } from "./TagContent.vue?vue&type=template&id=53782740&scoped=true&"
import script from "./TagContent.vue?vue&type=script&lang=ts&"
export * from "./TagContent.vue?vue&type=script&lang=ts&"
import style0 from "./TagContent.vue?vue&type=style&index=0&id=53782740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53782740",
  null
  
)

export default component.exports